import { computed, toValue } from 'vue';
import {
  REPORTS,
  MULTI_CHANNEL_REPORT_TYPES,
  BENCHMARK_REPORTS,
  COMPETITIVE_REPORTS,
  ADS_REPORT_TYPES,
  CONTENT_REPORT_TYPES,
  METRIC_TABLE_REPORTS,
  SINGLE_METRIC_REPORT_TYPE,
  ALL_GRAPH_REPORTS,
  CREATOR_REPORTS,
  ALL_METRIC_REPORTS,
  LINE_CHART_REPORTS,
  STACKED_BAR_CHART_REPORTS,
  BAR_CHART_REPORTS,
} from '@/app/dashboards/utils/reports.enum';
import { DATA_TYPES } from '@/app/dashboards/constants';
import { METRIC_TYPES } from '@/app/dashboards/reportConstants';

export function useReportType({ reportType, reportMetricType } = {}) {
  const type = computed(() => toValue(reportType));
  const metricType = computed(() => toValue(reportMetricType));

  const isAdsTotalMetric = computed(() => type.value === REPORTS.ADS_TOTAL_METRIC.value);

  const isMultiChannelReport = computed(() => MULTI_CHANNEL_REPORT_TYPES.includes(type.value));

  const isMultiMediaTypeReport = computed(
    () => type.value === REPORTS.MULTI_METRIC_MEDIA_TYPE.value,
  );

  const isBenchmarkReport = computed(() => BENCHMARK_REPORTS.includes(type.value));

  const isTotalMetricReportType = computed(() => type.value === REPORTS.TOTAL_METRIC.value);

  const isTotalGroupedMetricReport = computed(
    () => type.value === REPORTS.TOTAL_GROUPED_METRIC.value,
  );

  const isCreatorTotalGroupedMetricReport = computed(
    () => type.value === REPORTS.CREATOR_TOTAL_GROUPED_METRIC.value,
  );
  const isAdsTotalGroupedMetricReport = computed(
    () => type.value === REPORTS.ADS_TOTAL_GROUPED_METRIC.value,
  );

  const isCompetitiveReport = computed(() => COMPETITIVE_REPORTS.includes(type.value));

  const isCreatorReport = computed(() => CREATOR_REPORTS.includes(type.value));

  const isCustomMetricReport = computed(() => metricType.value === METRIC_TYPES.CUSTOM);

  const isMultiBrandReport = computed(() => type.value === REPORTS.MULTI_BRAND_METRIC.value);

  const isAdsReportType = computed(() => ADS_REPORT_TYPES.includes(type.value));

  const isContentReport = computed(() => CONTENT_REPORT_TYPES.includes(type.value));

  const isSingleMetricReport = computed(() =>
    Object.values(SINGLE_METRIC_REPORT_TYPE).includes(type.value),
  );

  const isTableReport = computed(() => METRIC_TABLE_REPORTS.includes(type.value));

  const isGraphReport = computed(() => ALL_GRAPH_REPORTS.includes(type.value));

  const isMetricReport = computed(() => ALL_METRIC_REPORTS.includes(type.value));

  const isLineChart = computed(() => LINE_CHART_REPORTS.includes(type.value));

  const isStackedBarChart = computed(() => STACKED_BAR_CHART_REPORTS.includes(type.value));

  const isBarChart = computed(() => BAR_CHART_REPORTS.includes(type.value));

  const isDoughnutChart = computed(() => REPORTS.DOUGHNUT_METRIC.value === type.value);

  const isHorizontalBarChart = computed(() => type.value === REPORTS.HORIZONTAL_BAR_METRIC.value);

  const isAdsStackedBarChart = computed(() => type.value === REPORTS.ADS_STACKED_BAR_METRIC.value);

  function isBenchmark(item) {
    return item?.data_type === DATA_TYPES.BENCHMARK;
  }

  return {
    isAdsReportType,
    isAdsTotalGroupedMetricReport,
    isAdsTotalMetric,
    isAdsStackedBarChart,
    isBenchmarkReport,
    isCompetitiveReport,
    isContentReport,
    isCreatorTotalGroupedMetricReport,
    isGraphReport,
    isBarChart,
    isStackedBarChart,
    isMetricReport,
    isMultiBrandReport,
    isMultiChannelReport,
    isMultiMediaTypeReport,
    isSingleMetricReport,
    isTableReport,
    isTotalGroupedMetricReport,
    isTotalMetricReportType,
    isCreatorReport,
    isCustomMetricReport,
    isLineChart,
    isDoughnutChart,
    isHorizontalBarChart,
    isBenchmark,
  };
}
